const SalesHomePage = () => {
  return (
    <div>
      <h1>Sales Homepage</h1>
    </div>
  );
};

export default SalesHomePage;
